/**
 * Mask/visibility keys that differ from live Tabulator column `field`.
 * Legacy masks still store execution_crm_step_id / custom_delete.
 */
export const CRM_COMM_VISIBILITY_FIELD_TO_TABULATOR_FIELD = Object.freeze({
  execution_crm_step_id: 'workflow_next_step_label',
});

/**
 * Resolve a visibility/mask key to a column that actually exists on the table.
 * Returns null when the column is absent (legacy/obsolete) — caller MUST skip.
 */
export function resolveCrmCommTabulatorColumnField(table, visibilityField) {
  if (!table || !visibilityField) return null;
  const alias = CRM_COMM_VISIBILITY_FIELD_TO_TABULATOR_FIELD[visibilityField];
  const candidates = alias ? [alias, visibilityField] : [visibilityField];
  for (const field of candidates) {
    try {
      if (table.getColumn?.(field)) return field;
    } catch (_) {
      // Tabulator throws when column is missing in some versions.
    }
  }
  return null;
}

/**
 * Safe hide/show that ignores unknown/legacy columns (no Column Hide Error).
 */
export function applyCrmCommColumnVisibilitySafely(table, visibilityMap, orderedFields) {
  if (!table || !visibilityMap || typeof visibilityMap !== 'object') return;
  const fields = Array.isArray(orderedFields) ? orderedFields : Object.keys(visibilityMap);
  for (const key of fields) {
    const field = resolveCrmCommTabulatorColumnField(table, key);
    if (!field) continue;
    try {
      if (visibilityMap[key] === false) table.hideColumn?.(field);
      else table.showColumn?.(field);
    } catch (_) {
      // Ignore obsolete mask keys.
    }
  }
}
